import React, { useContext, useState, useEffect } from "react";
import {
  InputAdornment,
  RadioGroup,
  Radio,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Checkbox,
  FormHelperText,
  Divider,
  Grid,
  FormControl,
  FormLabel,
  useMediaQuery,
  MenuItem,
} from "@material-ui/core";
import FlexView from "react-flexview/lib";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Controller, useForm } from "react-hook-form";
import {
  SESSION_ACTIONS,
  SessionContextStore,
} from "../../../../context/SessionContext";
import {
  EventEmitterService,
  EventKey,
} from "../../../../services/EventEmitterService";
import "../../UserProfile.scss";
import {
  UserProfileContextStore,
  ACTIONS,
} from "../../../../context/UserProfileContext";
import { Action } from "../../../../models/Action";
import { SessionService } from "../../../../services/SessionService";
import {
  FirebaseService,
  FirebaseConfigKey,
} from "../../../../services/FirebaseService";
import { isOver18 } from "../../../../services/utils";
import { DeclerationDisagreementPopup } from "../../../PopUps/DeclerationDisagreementPopup/DeclerationDisagreementPopup";
import { isCanada } from "../../../../services/utils";
import { DatePicker } from "@material-ui/pickers";
import { OptionalTag } from "../../../Core/OptionalTag";
import { BrowserView, MobileView } from "react-device-detect";
import { InsurancePurchaseContextStore } from "../../../../context/InsuracePurchaseContext";
import { SkyInformationPopover } from "../../../Core/Popover/SkyPopover";
import generalApi from "../../../../api/general.api";
import { BuyingInsuranceContextStore } from "../../../../context/BuyingInsuranceContext";

export const InsuranceHistorySection = (props) => {
  const context = useContext(UserProfileContextStore);
  let sessionContext = useContext(SessionContextStore);
  const insuranceContext = useContext(InsurancePurchaseContextStore);
  const { setError } = useContext(UserProfileContextStore);
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isMobilePhone = !useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [felonyAllow, setFelonyAllow] = useState(false);
  const [incidentsorlossesAllow, setIncidentsorlossesAllow] = useState(false);
  const [overflightsOfPeopleAllow, setOverflightsOfPeopleAllow] =
    useState(false);
  const [
    commercialOperationsByRPACPilotAllow,
    setCommercialOperationsByRPACPilotAllow,
  ] = useState(false);
  const [
    eventsWithLargeNumberOfPeopleAllow,
    setEventsWithLargeNumberOfPeopleAllow,
  ] = useState(false);
  const buyingInsuranceContext = useContext(BuyingInsuranceContextStore);

  const { intendedUsesLoaded, loadIntendedUses, intendedUses } =
    buyingInsuranceContext;
  const {
    register,
    triggerValidation,
    setValue,
    control,
    errors,
    getValues,
    watch,
    reset,
  } = useForm(
    SessionService.isLoggedIn()
      ? {
          defaultValues: {
            is_commercial: sessionContext.user.commercial ? "yes" : "no",
            dob_checkbox: isOver18(sessionContext.user.dateOfBirth),
            events_with_large_number_of_people:
              sessionContext.user.declarationsAgreement == true
                ? sessionContext.user.eventsWithLargeNumberOfPeople
                : undefined,
            commercial_operations_by_RPAC_pilot:
              sessionContext.user.declarationsAgreement == true
                ? sessionContext.user.commercialOperationsByRpacPilot
                : undefined,
            overflights_of_people:
              sessionContext.user.declarationsAgreement == true
                ? sessionContext.user.overflightsOfPeople
                : undefined,
            had_incidents_or_losses: sessionContext.user.hadIncidentsOrLosses,
            had_felony: sessionContext.user.hadFelony,
          },
          mode: "onChange",
        }
      : { mode: "onChange" }
  );

  useEffect(() => {
    if (!!sessionContext.user.declinations) {
      sessionContext.user.declinations.forEach((e) => {
        if (e.override_type === "Allow") {
          if (e.property === "HadFelony") {
            setFelonyAllow(true);
          }
          if (e.property === "HadIncidentsOrLosses") {
            setIncidentsorlossesAllow(true);
          }
          if (e.property === "OverflightsOfPeople") {
            setOverflightsOfPeopleAllow(true);
          }
          if (e.property === "EventsWithLargeNumberOfPeople") {
            setEventsWithLargeNumberOfPeopleAllow(true);
          }
          if (e.property === "CommercialOperationsByRpacPilot") {
            setCommercialOperationsByRPACPilotAllow(true);
          }
        }
      });
    }
  }, [sessionContext.user.declinations]);
  let hadIncidentsOrLossesWatch = watch("had_incidents_or_losses");
  let hadFelonyWatch = watch("had_felony");
  let felonyDescriptionWatch = watch("felony_description");
  let incidentsOrLossesDescriptionWatch = watch(
    "incidents_or_losses_description"
  );
  let incidentsOrLossesDateWatch = watch("incidents_or_losses_date");
  let incidentsOrLossesValueWatch = watch("incidents_or_losses_value");
  let incidentsOrLossesMoreClaimsWatch = watch(
    "incidents_or_losses_more_claims"
  );
  let overflightsOfPeopleWatch = watch("overflights_of_people");
  let beyondVisualLineOfSightWatch = watch(
    "operate_beyond_visual_line_of_sight"
  );
  let overflightsOfPeopleDescriptionWatch = watch(
    "overflights_of_people_description"
  );
  let eventsWithLargeNumberOfPeopleWatch = watch(
    "events_with_large_number_of_people"
  );
  let eventsWithLargeNumberOfPeopleDeclarationWatch = watch(
    "events_with_large_number_of_people_declaration"
  );
  let eventsWithLargeNumberOfPeopleDeclarationDescriptionWatch = watch(
    "events_with_large_number_of_people_declaration_description"
  );
  let commercialOperationsByRPACPilotWatch = watch(
    "commercial_operations_by_RPAC_pilot"
  );
  let commercialOperationsByRPACPilotDescriptionWatch = watch(
    "commercial_operations_by_RPAC_pilot_description"
  );
  let intendedUseWatch = watch("intended_use");

  useEffect(() => {
    if (intendedUsesLoaded) return;
    loadIntendedUses();
  }, [intendedUsesLoaded]);

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(
      EventKey.USER_PROFILE_SAVE,
      async () => {
        let valid = await triggerValidation();
        if (valid) {
          const insuranceHistoryFormValues = getValues();
          if (!insuranceHistoryFormValues["is_commercial"]) {
            insuranceHistoryFormValues["is_commercial"] = sessionContext.user
              .commercial
              ? "yes"
              : "no";
          }
          //let oldDeniedDeclarations = sessionContext.user.declinations.filter(x=>x.property === 'DeniedDeclarations')
          //let allowedOldDeniedDeclarations = oldDeniedDeclarations.length === 0 ? false : oldDeniedDeclarations[0].allowed
          // if (insuranceHistoryFormValues.declarations_agreement === 'false' && !allowedOldDeniedDeclarations) {
          //     setShowConfirmDialog(true);
          // } else {
          //     context.dispatch(new Action(ACTIONS.SAVE_INSURANCE_HISTORY, insuranceHistoryFormValues));
          // }
          context.dispatch(
            new Action(
              ACTIONS.SAVE_INSURANCE_HISTORY,
              insuranceHistoryFormValues
            )
          );
        } else {
          setError("Check for required fields/invalid data");
        }
      }
    );

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id);
    };
  }, []);

  React.useEffect(() => {
    reset({
      had_claim: sessionContext.user.droneLoss ? "yes" : "no",
      had_incidents_or_losses:
        sessionContext.user.hadIncidentsOrLosses != undefined
          ? sessionContext.user.hadIncidentsOrLosses.toString()
          : undefined,
      had_felony:
        sessionContext.user.hadFelony != undefined
          ? sessionContext.user.hadFelony.toString()
          : undefined,
      is_commercial: sessionContext.user.commercial ? "yes" : "no",
      drone_loss_description: sessionContext.user.droneLossDescription,
      felony_description: sessionContext.user.felonyDescription,
      incidents_or_losses_description:
        sessionContext.user.incidentsOrLossesDescription,
      dob_checkbox: sessionContext.user.remotePilotAirmanCertCheckbox,
      overflights_of_people:
        sessionContext.user.overflightsOfPeople != undefined
          ? sessionContext.user.overflightsOfPeople.toString()
          : undefined,
      overflights_of_people_description:
        sessionContext.user.overflightsOfPeopleDescription,
      commercial_operations_by_RPAC_pilot:
        sessionContext.user.commercialOperationsByRpacPilot != undefined
          ? sessionContext.user.commercialOperationsByRpacPilot.toString()
          : undefined,
      commercial_operations_by_RPAC_pilot_description:
        sessionContext.user.commercialOperationsByRpacPilotDescription,
      events_with_large_number_of_people:
        sessionContext.user.eventsWithLargeNumberOfPeople != undefined
          ? sessionContext.user.eventsWithLargeNumberOfPeople.toString()
          : undefined,
      events_with_large_number_of_people_declaration_description:
        sessionContext.user.eventsWithLargeNumberOfPeopleDeclarationDescription,
      events_with_large_number_of_people_declaration:
        sessionContext.user.eventsWithLargeNumberOfPeopleDeclaration !=
        undefined
          ? sessionContext.user.eventsWithLargeNumberOfPeopleDeclaration.toString()
          : undefined,
      incidents_or_losses_date: sessionContext.user.incidentsOrLossesDate,
      incidents_or_losses_value: sessionContext.user.incidentsOrLossesValue,
      incidents_or_losses_more_claims:
        sessionContext.user.incidentsOrLossesMoreClaims === undefined
          ? undefined
          : sessionContext.user.incidentsOrLossesMoreClaims
          ? "true"
          : "false",
      operate_beyond_visual_line_of_sight:
        sessionContext.user.operateBeyondVisualOfSight != undefined
          ? sessionContext.user.operateBeyondVisualOfSight.toString()
          : undefined,
      intended_use:
        sessionContext.user.intendedUse != undefined
          ? sessionContext.user.intendedUse
          : undefined,
    });
  }, [sessionContext.user]);

  const validationIncidentsOrLosseComment = (comment) => {
    if (hadIncidentsOrLossesWatch == "true") {
      return comment.trim() !== "";
    } else {
      return true;
    }
  };
  const validationHadFelonyWatchComment = (comment) => {
    if (hadFelonyWatch == "true") {
      return comment.trim() !== "";
    } else {
      return true;
    }
  };
  const validationOverflightsOfPeopleWatchComment = (comment) => {
    if (overflightsOfPeopleWatch == false) {
      return comment.trim() !== "";
    } else {
      return true;
    }
  };

  const validationEventsWithLargeNumberOfPeopleWatchComment = (comment) => {
    if (eventsWithLargeNumberOfPeopleWatch == true) {
      return comment.trim() !== "";
    } else {
      return true;
    }
  };

  const validationCommercialOperationsByRPACPilotWatchComment = (comment) => {
    if (commercialOperationsByRPACPilotWatch == false) {
      return comment.trim() !== "";
    } else {
      return true;
    }
  };

  const showEventsWithLargeNumberOfPeopleComment = () => {
    if (
      eventsWithLargeNumberOfPeopleWatch == "true" &&
      insuranceContext.selectedOption.liabilityLimit != 1000000 &&
      insuranceContext.selectedOption.liabilityLimit != 500000
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      <Grid container>
        <Controller
          control={control}
          name="intended_use"
          className="margin-top-basic"
          rules={{ required: true }}
          as={
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                select
                variant="outlined"
                className="margin-right-basic"
                label="What is the main intended use?"
                error={!!errors.intended_use}
                helperText={!!errors.intended_use ? "Required" : ""}
                value={watch("intended_use") || ""}
                onChange={(e) => setValue("intended_use", e.target.value)}
              >
                <MenuItem value="">
                  <em>Select intended use</em>
                </MenuItem>
                {intendedUses &&
                  intendedUses.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option == "Private / Hobby"
                        ? "Recreational Flights (under current Part 107)"
                        : option}
                    </MenuItem>
                  ))}
              </TextField>
              {watch("intended_use") == "Private / Hobby" && (
                <div
                  className="declaration-text margin-top-small"
                  style={{ color: "#2196F3" }}
                >
                  <InfoOutlinedIcon style={{ marginRight: "5px" }} />
                  Recreational flights coverage is limited to $2,000,000
                  Liability and $10,000 Hull value.
                </div>
              )}
            </Grid>
          }
        />
        <Controller
          control={control}
          name="had_incidents_or_losses"
          className="margin-top-basic"
          rules={{ required: true }}
          as={
            <Grid container>
              <Grid item xs={12} sm={7}>
                <div className="declaration-text margin-top-small">
                  {FirebaseService.getValue(
                    FirebaseConfigKey.INCIDENTS_LOSSES_QUESTION
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={5}>
                <RadioGroup
                  className={isMobilePhone ? "margin-top-basic" : ""}
                  name="had_incidents_or_losses"
                >
                  <Grid
                    container
                    justifyContent={!isMobilePhone ? "flex-end" : "flex-start"}
                  >
                    <FormControlLabel
                      value={"false"}
                      control={
                        <Radio
                          checked={
                            hadIncidentsOrLossesWatch === "false" &&
                            hadIncidentsOrLossesWatch != undefined
                          }
                          color="primary"
                        />
                      }
                      label="No"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={"true"}
                      control={
                        <Radio
                          checked={
                            hadIncidentsOrLossesWatch === "true" &&
                            hadIncidentsOrLossesWatch != undefined
                          }
                          color="primary"
                        />
                      }
                      label="Yes"
                      labelPlacement="end"
                    />
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          }
        />
      </Grid>
      {!!errors.had_incidents_or_losses && (
        <FormHelperText error>Required</FormHelperText>
      )}

      <TextField
        style={{
          display: hadIncidentsOrLossesWatch == "true" ? undefined : "none",
        }}
        className="margin-top-small margin-bottom-basic"
        fullWidth
        InputLabelProps={{ shrink: !!incidentsOrLossesDescriptionWatch }}
        variant="outlined"
        label="Please fully describe the accident, incident, or loss:"
        name="incidents_or_losses_description"
        multiline
        disabled={
          incidentsorlossesAllow &&
          sessionContext.user.incidentsOrLossesDescription !== ""
        }
        rows={isMobile ? 3 : 1}
        inputRef={register({
          required: hadIncidentsOrLossesWatch == "true",
          validate: validationIncidentsOrLosseComment,
        })}
        error={!!errors.incidents_or_losses_description}
        helperText={!!errors.incidents_or_losses_description && "Required"}
      />
      <FlexView>
        <Controller
          style={{
            display: hadIncidentsOrLossesWatch == "true" ? undefined : "none",
          }}
          as={
            <DatePicker
              disableFuture
              openTo="year"
              views={["year", "month"]}
              label={"Date of incident"}
              error={!!errors.incidents_or_losses_date}
              inputVariant="outlined"
              helperText={!!errors.incidents_or_losses_date && "Required"}
            />
          }
          onChange={(date) => {
            setValue("incidentsOrLossesDateWatch", new Date(date[0]));
            return new Date(date[0]);
          }}
          rules={{
            required: true,
          }}
          inputRef={register({
            required:
              hadIncidentsOrLossesWatch == "true" && !incidentsorlossesAllow,
          })}
          name="incidents_or_losses_date"
          value={watch("incidents_or_losses_date")}
          disabled={
            incidentsorlossesAllow &&
            sessionContext.user.incidentsOrLossesDate !== undefined
          }
          fullWidth
          defaultValue={null}
          control={control}
        />
        <FlexView>
          {/* <SkyInformationPopover eventId={'additional-insured'}>
                            <div className="text-body bold">Please provide the total value of damages incurred by you, your company, or any third party resulting from the accident, incident, or loss.</div>
                        </SkyInformationPopover> */}
          <TextField
            style={{
              display: hadIncidentsOrLossesWatch == "true" ? undefined : "none",
            }}
            className="margin-left-basic"
            InputLabelProps={{ shrink: !!incidentsOrLossesValueWatch }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <OptionalTag />{" "}
                </InputAdornment>
              ),
            }}
            variant="outlined"
            label="Claim Value"
            name="incidents_or_losses_value"
            fullWidth
            value={incidentsOrLossesValueWatch}
            rows={isMobile ? 3 : 1}
            disabled={incidentsorlossesAllow}
            inputRef={register({
              validate: (x) => x >= 0 || x.trim() === "" || x === undefined,
            })}
            error={!!errors.incidents_or_losses_value}
            helperText={!!errors.incidents_or_losses_value && "Invalid value"}
          />
        </FlexView>
      </FlexView>

      {hadIncidentsOrLossesWatch == "true" && (
        <Controller
          style={{
            display: hadIncidentsOrLossesWatch == "true" ? undefined : "none",
          }}
          control={control}
          name="incidents_or_losses_more_claims"
          className="margin-top-basic"
          rules={{ required: !incidentsorlossesAllow }}
          as={
            <Grid container>
              <Grid item xs={12} sm={7}>
                <div className="declaration-text margin-top-small">
                  Where there any other accidents, inacidents, or losses, apart
                  from the one mentioned above?
                </div>
                {!!errors.incidents_or_losses_more_claims && (
                  <FormHelperText error>Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={5}>
                <RadioGroup
                  className={isMobilePhone ? "margin-top-basic" : ""}
                  name="incidents_or_losses_more_claims"
                >
                  <Grid
                    container
                    justifyContent={!isMobilePhone ? "flex-end" : "flex-start"}
                  >
                    <FormControlLabel
                      value={"false"}
                      control={
                        <Radio
                          checked={incidentsOrLossesMoreClaimsWatch === "false"}
                          color="primary"
                        />
                      }
                      label="No"
                      labelPlacement="end"
                      disabled={
                        incidentsorlossesAllow &&
                        sessionContext.user.incidentsOrLossesMoreClaims !==
                          undefined
                      }
                    />
                    <FormControlLabel
                      value={"true"}
                      control={
                        <Radio
                          checked={incidentsOrLossesMoreClaimsWatch === "true"}
                          color="primary"
                        />
                      }
                      label="Yes"
                      labelPlacement="end"
                      disabled={
                        incidentsorlossesAllow &&
                        sessionContext.user.incidentsOrLossesMoreClaims !==
                          undefined
                      }
                    />
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          }
        />
      )}

      {hadIncidentsOrLossesWatch == "true" && <Divider />}

      <Controller
        name="had_felony"
        className="margin-top-basic"
        control={control}
        rules={{ required: true }}
        as={
          <Grid container>
            <Grid
              container
              justifyContent="center"
              direction="column"
              item
              xs={12}
              sm={7}
            >
              <div className="declaration-text">
                {FirebaseService.getValue(FirebaseConfigKey.FELONY_QUESTION)}
              </div>
              <div>
                <FlexView column>
                  {FirebaseService.getValue(
                    FirebaseConfigKey.FELONY_QUESTION_SECTION
                  )
                    .split("*")
                    .map((question) => (
                      <div
                        style={{ width: "100%" }}
                        className="declaration-text margin-top-small"
                      >
                        {question}
                      </div>
                    ))}
                  {!!errors.had_felony && (
                    <FormHelperText error>Required</FormHelperText>
                  )}
                </FlexView>
              </div>
            </Grid>
            <Grid item xs={12} sm={5}>
              <RadioGroup className={isMobilePhone ? "margin-top-basic" : ""}>
                <Grid
                  container
                  justifyContent={!isMobilePhone ? "flex-end" : "flex-start"}
                >
                  <FormControlLabel
                    value={"false"}
                    control={
                      <Radio
                        checked={hadFelonyWatch === "false"}
                        color="primary"
                      />
                    }
                    label="No"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value={"true"}
                    control={
                      <Radio
                        checked={hadFelonyWatch === "true"}
                        color="primary"
                      />
                    }
                    label="Yes"
                    labelPlacement="end"
                  />
                </Grid>
              </RadioGroup>
            </Grid>
          </Grid>
        }
      />

      {hadFelonyWatch == "true" && (
        <>
          <Grid container className="gray margin-top-basic">
            <div>
              <div>
                Please provide details of the felony conviction, including the
                date of the charge, location of the incident, and a description
                of the charge:
              </div>
            </div>
          </Grid>
          <TextField
            style={{ display: hadFelonyWatch == "true" ? undefined : "none" }}
            className="margin-top-small margin-bottom-basic"
            fullWidth
            InputLabelProps={{ shrink: !!felonyDescriptionWatch }}
            variant="outlined"
            name="felony_description"
            multiline
            disabled={
              felonyAllow && sessionContext.user.felonyDescription !== ""
            }
            rows={isMobile ? 3 : 1}
            inputRef={register({
              required: hadFelonyWatch == "true",
              validate: validationHadFelonyWatchComment,
            })}
            error={!!errors.felony_description}
            helperText={!!errors.felony_description && "Required"}
          />
        </>
      )}

      <Divider />

      <Grid container>
        <div
          className={`${
            !isMobile ? "text-small-title bold" : "text-title"
          } black`}
        >
          Declarations
        </div>
        <br></br>
        <Controller
          control={control}
          name="overflights_of_people"
          rules={{ required: true }}
          as={
            <Grid
              container
              className="margin-top-basic"
              direction="row"
              wrap={isMobile ? "wrap" : "nowrap"}
            >
              <Grid
                container
                justifyContent="center"
                direction="column"
                item
                xs={12}
                sm={7}
              >
                <div>
                  {FirebaseService.getValue(
                    FirebaseConfigKey.OVERFLIGHT_OF_PEOPLE
                  )}
                  {!!errors.overflights_of_people && (
                    <FormHelperText error>Required</FormHelperText>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={5}>
                <RadioGroup
                  className={isMobilePhone ? "margin-top-basic" : ""}
                  name="overflights_of_people"
                >
                  <Grid
                    container
                    justifyContent={!isMobilePhone ? "flex-end" : "flex-start"}
                  >
                    <FormControlLabel
                      value={"false"}
                      control={
                        <Radio
                          checked={overflightsOfPeopleWatch === "false"}
                          color="primary"
                        />
                      }
                      label="No"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={"true"}
                      control={
                        <Radio
                          checked={overflightsOfPeopleWatch === "true"}
                          color="primary"
                        />
                      }
                      label="Yes"
                      labelPlacement="end"
                    />
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          }
        />

        {overflightsOfPeopleWatch == "false" && (
          <>
            <Grid container className="gray margin-top-basic">
              <div>
                <div>Please provide more details</div>
              </div>
            </Grid>
            <TextField
              style={{
                display:
                  overflightsOfPeopleWatch == "false" ? undefined : "none",
              }}
              className="margin-top-small margin-bottom-basic"
              fullWidth
              InputLabelProps={{
                shrink: !!overflightsOfPeopleDescriptionWatch,
              }}
              variant="outlined"
              name="overflights_of_people_description"
              multiline
              disabled={
                overflightsOfPeopleAllow &&
                sessionContext.user.overflightsOfPeopleDescription !== ""
              }
              rows={isMobile ? 3 : 1}
              inputRef={register({
                required: overflightsOfPeopleWatch == "false",
                validate: validationOverflightsOfPeopleWatchComment,
              })}
              error={!!errors.overflights_of_people_description}
              helperText={
                !!errors.overflights_of_people_description && "Required"
              }
            />
          </>
        )}

        <Controller
          control={control}
          name="events_with_large_number_of_people"
          rules={{ required: true }}
          as={
            <Grid
              container
              className="margin-top-basic"
              direction="row"
              wrap={isMobile ? "wrap" : "nowrap"}
            >
              <Grid
                container
                justifyContent="center"
                direction="column"
                item
                xs={12}
                sm={7}
              >
                <div>
                  <div>
                    Will any flights be flown: <br />
                    a) outside over people under the{" "}
                    {isCanada() ? "Transport Canada" : "FAA"} Operation of
                    Unmanned Aircraft Systems Over People rule or with a waiver?
                    <br />
                    b) indoors where people are present?
                  </div>
                  {!!errors.events_with_large_number_of_people && (
                    <FormHelperText error>Required</FormHelperText>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={5}>
                <RadioGroup
                  className={isMobilePhone ? "margin-top-basic" : ""}
                  name="events_with_large_number_of_people"
                >
                  <Grid
                    container
                    justifyContent={!isMobilePhone ? "flex-end" : "flex-start"}
                  >
                    <FormControlLabel
                      value={"false"}
                      control={
                        <Radio
                          checked={
                            eventsWithLargeNumberOfPeopleWatch === "false"
                          }
                          color="primary"
                        />
                      }
                      label="No"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={"true"}
                      control={
                        <Radio
                          checked={
                            eventsWithLargeNumberOfPeopleWatch === "true"
                          }
                          color="primary"
                        />
                      }
                      label="Yes"
                      labelPlacement="end"
                    />
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          }
        />
        {showEventsWithLargeNumberOfPeopleComment() && (
          <>
            <Controller
              control={control}
              name="events_with_large_number_of_people_declaration"
              rules={{ required: showEventsWithLargeNumberOfPeopleComment() }}
              as={
                <Grid
                  container
                  className="margin-top-basic"
                  direction="row"
                  wrap={isMobile ? "wrap" : "nowrap"}
                >
                  <Grid
                    container
                    justifyContent="center"
                    direction="column"
                    item
                    xs={12}
                    sm={7}
                  >
                    <div>
                      <div>
                        I confirm that all operators will observe a minimum
                        horizontal distance setback equivalent to one foot for
                        every one-foot increase in altitude, subject to a
                        minimum setback of 20 feet at all times, between any
                        operated drone and any persons other than the drone
                        operator or drone crew.
                      </div>
                      {!!errors.events_with_large_number_of_people_declaration && (
                        <FormHelperText error>Required</FormHelperText>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <RadioGroup
                      className={isMobilePhone ? "margin-top-basic" : ""}
                      name="events_with_large_number_of_people_declaration"
                    >
                      <Grid
                        container
                        justifyContent={
                          !isMobilePhone ? "flex-end" : "flex-start"
                        }
                      >
                        <FormControlLabel
                          value={"false"}
                          control={
                            <Radio
                              checked={
                                eventsWithLargeNumberOfPeopleDeclarationWatch ===
                                "false"
                              }
                              color="primary"
                            />
                          }
                          label="No"
                          labelPlacement="end"
                          disabled={
                            !showEventsWithLargeNumberOfPeopleComment() &&
                            eventsWithLargeNumberOfPeopleAllow &&
                            sessionContext.user
                              .eventsWithLargeNumberOfPeopleDeclaration !==
                              undefined
                          }
                        />
                        <FormControlLabel
                          value={"true"}
                          control={
                            <Radio
                              checked={
                                eventsWithLargeNumberOfPeopleDeclarationWatch ===
                                "true"
                              }
                              color="primary"
                            />
                          }
                          label="Yes"
                          labelPlacement="end"
                          disabled={
                            !showEventsWithLargeNumberOfPeopleComment() &&
                            eventsWithLargeNumberOfPeopleAllow &&
                            sessionContext.user
                              .eventsWithLargeNumberOfPeopleDeclaration !==
                              undefined
                          }
                        />
                      </Grid>
                    </RadioGroup>
                  </Grid>
                </Grid>
              }
            />
            <>
              {" "}
              <Grid
                container
                className="gray margin-top-basic"
                justifyContent="center"
              >
                <div className="gray margin-top-basic">
                  <div>
                    <b>Please provide additional details:</b>
                  </div>
                  <br />
                  <div>
                    &bull; If any operator will be flying at events, concerts,
                    festivals, or areas where groups of people are present,
                    please provide their full name, FAA license statuses, total
                    flight hours and a description of their experience.
                  </div>
                  <br />
                  <div>
                    &bull; Please describe any expected upcoming operations at
                    events such as concerts, festivals, or areas where groups of
                    people are present. Include a detailed description of
                    operations, including your maximum vertical elevation and
                    planned horizontal setback, event name, date of occurrence,
                    and approximate locations of flight.
                  </div>
                  <br />
                  <div>
                    &bull; Describe safety measures enforced to minimize the
                    risk of harm or injury to bystanders operators will observe
                    during operations.
                  </div>
                  <br />
                  {!!errors.events_with_large_number_of_people && (
                    <FormHelperText error>Required</FormHelperText>
                  )}
                </div>
              </Grid>
              <TextField
                className="margin-top-small margin-bottom-basic"
                fullWidth
                InputLabelProps={{
                  shrink:
                    !!eventsWithLargeNumberOfPeopleDeclarationDescriptionWatch,
                }}
                variant="outlined"
                name="events_with_large_number_of_people_declaration_description"
                multiline
                disabled={
                  eventsWithLargeNumberOfPeopleAllow &&
                  showEventsWithLargeNumberOfPeopleComment()
                }
                rows={5}
                inputRef={register({
                  required:
                    !eventsWithLargeNumberOfPeopleAllow &&
                    eventsWithLargeNumberOfPeopleWatch == "true" &&
                    showEventsWithLargeNumberOfPeopleComment(),
                  validate: validationEventsWithLargeNumberOfPeopleWatchComment,
                })}
                error={
                  !!errors.events_with_large_number_of_people_declaration_description
                }
                helperText={
                  !!errors.events_with_large_number_of_people_declaration_description &&
                  "Required"
                }
              />
            </>
          </>
        )}
        <Controller
          control={control}
          name="commercial_operations_by_RPAC_pilot"
          rules={{ required: true }}
          as={
            <Grid
              container
              className="margin-top-basic"
              direction="row"
              wrap={isMobile ? "wrap" : "nowrap"}
            >
              <Grid
                container
                justifyContent="center"
                direction="column"
                item
                xs={12}
                sm={7}
              >
                <div>
                  <div>{`Will all operations be conducted by an operator who holds a current Remote Pilot Airman Certificate (RPAC) with 24 month recurrency completed or Under a Certificate of Authorization or Waiver (public entities only)?`}</div>
                  {!!errors.commercial_operations_by_RPAC_pilot && (
                    <FormHelperText error>Required</FormHelperText>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} sm={5}>
                <RadioGroup
                  className={isMobilePhone ? "margin-top-basic" : ""}
                  name="overflights_of_people"
                >
                  <Grid
                    container
                    justifyContent={!isMobilePhone ? "flex-end" : "flex-start"}
                  >
                    <FormControlLabel
                      value={"false"}
                      control={
                        <Radio
                          checked={
                            commercialOperationsByRPACPilotWatch === "false"
                          }
                          color="primary"
                        />
                      }
                      label="No"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={"true"}
                      control={
                        <Radio
                          checked={
                            commercialOperationsByRPACPilotWatch === "true"
                          }
                          color="primary"
                        />
                      }
                      label="Yes"
                      labelPlacement="end"
                    />
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          }
        />

        {commercialOperationsByRPACPilotWatch == "false" && (
          <>
            <Grid container className="gray margin-top-basic">
              <div>
                <div>Please provide more details</div>
              </div>
            </Grid>
            <TextField
              style={{
                display:
                  commercialOperationsByRPACPilotWatch == "false"
                    ? undefined
                    : "none",
              }}
              className="margin-top-small margin-bottom-basic"
              fullWidth
              InputLabelProps={{
                shrink: !!commercialOperationsByRPACPilotDescriptionWatch,
              }}
              variant="outlined"
              name="commercial_operations_by_RPAC_pilot_description"
              multiline
              disabled={
                commercialOperationsByRPACPilotAllow &&
                sessionContext.user
                  .commercialOperationsByRpacPilotDescription !== ""
              }
              rows={isMobile ? 3 : 1}
              inputRef={register({
                required: commercialOperationsByRPACPilotWatch == "false",
                validate: validationCommercialOperationsByRPACPilotWatchComment,
              })}
              error={!!errors.commercial_operations_by_RPAC_pilot_description}
              helperText={
                !!errors.commercial_operations_by_RPAC_pilot_description &&
                "Required"
              }
            />
          </>
        )}
        <Controller
          control={control}
          name="operate_beyond_visual_line_of_sight"
          rules={{ required: true }}
          as={
            <Grid
              container
              className="margin-top-basic"
              direction="row"
              wrap={isMobile ? "wrap" : "nowrap"}
            >
              <Grid
                container
                justifyContent="center"
                direction="column"
                item
                xs={12}
                sm={7}
              >
                <div>
                  {FirebaseService.getValue(
                    FirebaseConfigKey.BEYOND_VISUAL_LINE_OF_SIGHT_QUESTION
                  )}
                  {!!errors.operate_beyond_visual_line_of_sight && (
                    <FormHelperText error>Required</FormHelperText>
                  )}
                  <SkyInformationPopover eventId={"bvlos-popup"}>
                    <div className="text-small">
                      {" "}
                      This question should only be answered “yes” if you have a
                      waiver to fly Beyond Visual Line of Sight from the FAA or
                      other international regulatory body. No other operations
                      beyond visual line of sight are permitted.
                    </div>
                  </SkyInformationPopover>{" "}
                </div>
              </Grid>
              <Grid item xs={12} sm={5}>
                <RadioGroup
                  className={isMobilePhone ? "margin-top-basic" : ""}
                  name="operate_beyond_visual_line_of_sight"
                >
                  <Grid
                    container
                    justifyContent={!isMobilePhone ? "flex-end" : "flex-start"}
                  >
                    <FormControlLabel
                      value={"false"}
                      control={
                        <Radio
                          checked={beyondVisualLineOfSightWatch === "false"}
                          color="primary"
                        />
                      }
                      label="No"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={"true"}
                      control={
                        <Radio
                          checked={beyondVisualLineOfSightWatch === "true"}
                          color="primary"
                        />
                      }
                      label="Yes"
                      labelPlacement="end"
                    />
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
          }
        />
      </Grid>
    </>
  );
};
